import devicesTemplate from './devices.html';

const SELECTED_DEVICE_LOCAL_STORAGE_KEY = 'Selected-Device';

export default angular
  .module('main.locations.edit.tabs.devices', [])

  .directive('editLocationDevicesTab', () => {
    return {
      restrict: 'E',
      template: devicesTemplate,
      scope: {},
      controller: ($scope,
                   $rootScope,
                   $q,
                   $filter,
                   $interval,
                   $state,
                   utils,
                   config,
                   ToastsService,
                   EditLocationDataProvider) => {
        const $t = $filter('translate');
        $scope.dataProvider = EditLocationDataProvider.instance;

        $scope.deviceStatuses = config.getConfigByKey('deviceConnectionStatuses');
        $scope.timeFormatStr = $t('datetime.mdyHM12');
        $scope.selectedDeviceStatusId = 2;
        $scope.showNoDevicesFoundMessage = false;

        // Reload devices interval
        const DEVICES_UPDATE_INTERVAL = 5000;
        let reloadDevicesInterval;

        angular.extend($scope, {
          filterByStatus: filterByStatus,
          onAddDeviceButtonClick: onAddDeviceButtonClick,
          onViewDeviceButtonClick: onViewDeviceButtonClick,
          onCloneDeviceButtonClick: onCloneDeviceButtonClick,
          onShowMoreTagsButtonClick: onShowMoreTagsButtonClick,
          onDeleteDeviceButtonClick: onDeleteDeviceButtonClick,
          copyToClipboard: $rootScope.copyToClipboard,
          isGateway: isGateway,
          searchLocations: searchLocations,
          selectLocation: selectLocation
        });

        // Remove locations refresh interval
        $scope.$on('$destroy', () => {
          stopDevicesRefresh();
        });

        init();

        function init() {
          $scope.loading = true;
          initWatchers();

          return $q.all([
            $scope.dataProvider.locationDevicesResource.init(),
            $scope.dataProvider.deviceTypesResource.init(),
            $scope.dataProvider.locationDeviceBehaviorsResource.init(),
            $scope.dataProvider.locationIdResource.init(),
            $scope.dataProvider.locationOrganizationIdResource.init(),
            $scope.dataProvider.currentOrganizationResource.init()
          ])
            .then(() => {
              processDevices();
              startDevicesRefresh();
              $scope.loading = false;

              // Reload devices when switching to 'devices' tab
              $scope.$watch('dataProvider.activeTab', (newVal, oldVal) => {
                if (newVal === 'devices') {
                  startDevicesRefresh();
                } else if (oldVal === 'devices') {
                  stopDevicesRefresh();
                }
              });
            }, (err) => {
              // utils.handleApiError(err);
              $scope.loading = false;
            });
        }

        function initWatchers() {
          $scope.$watchGroup([
            'loading',
            'otherDevices',
            'gateways',
            'dataProvider.locationDevicesResource.value',
            'searchVal',
            'selectedDeviceStatusId'
          ], () => {
            $scope.showNoDevicesFoundMessage = checkNoDevicesFound();
          });
        }

        /**
         * Reload devices every 5 sec
         */
        function startDevicesRefresh() {
          if (reloadDevicesInterval) {
            $interval.cancel(reloadDevicesInterval);
          }

          reloadDevicesInterval = $interval(() => {
            $scope.dataProvider.locationDevicesResource.init(true)
              .then(() => processDevices());
          }, DEVICES_UPDATE_INTERVAL);
        }

        function stopDevicesRefresh() {
          if (reloadDevicesInterval) {
            $interval.cancel(reloadDevicesInterval);
          }
        }

        function processDevices() {
          let devices = angular.copy($scope.dataProvider.locationDevicesResource.value);

          // Add additional information to the device object
          devices.forEach(device => {
            let type = $scope.dataProvider.deviceTypesResource.value.find(t => t.id === device.type);

            device.typeDesc = type.name;
            device.deviceListIcon = utils.getDeviceTypeIconName(type);
            device.goalDesc = $scope.dataProvider.locationDeviceBehaviorsResource
              .value[device.type]
              ?.find(goal => goal.id === device.goalId)
              ?.name;
          });

          // Devices grouped by their gateway or virtual zone.
          // Referenced either by`proxyId` (gateways) or by `zoneId` (zones).
          let devicesGroupedByProxy = devices
            .filter(device => devices.some(d => d.proxyId === device.id || d.zoneId === device.id))
            .map(proxyDevice => {
              // A proxy device is a zone when it's referenced by children via `zoneId`.
              let isZone = devices.some(d => d.zoneId === proxyDevice.id);
              let fallbackTitle = isZone ? $t('devices.unknownZone') : $t('devices.unknownGateway');
              let list = {
                title: proxyDevice.typeDesc || proxyDevice.desc || fallbackTitle,
                device: proxyDevice,
                id: proxyDevice.id,
                devices: devices.filter(d => d.proxyId === proxyDevice.id || d.zoneId === proxyDevice.id)
              };
              list.devices.unshift(proxyDevice);
              return list;
            });

          // All other devices
          let unrecognizedDevices = [];
          let otherDevices = devices
            .filter(device => !devicesGroupedByProxy.some(proxy => proxy.devices.some(d => d.id === device.id)))
            .filter(device => {
              if (!device.type) {
                unrecognizedDevices.push(device);
              }
              return !!device.type;
            });

          $scope.gateways = devicesGroupedByProxy;
          $scope.otherDevices = otherDevices;
          $scope.unrecognizedDevices = unrecognizedDevices;
        }

        /**
         * Filter devices list by device status
         * @param device
         * @return {boolean}
         */
        function filterByStatus(device) {
          if ($scope.selectedDeviceStatusId === 0) {
            return device.connected === false;
          } else if ($scope.selectedDeviceStatusId === 1) {
            return device.connected === true;
          }
          return true;
        }

        function onAddDeviceButtonClick() {
          if ($scope.loading) {
            return;
          }
          $state.go('main.devices.new', {
            from: 'location',
            locationId: $scope.dataProvider.locationIdResource.value
          });
          $rootScope.$emit('refreshChooseMenuEvent', 'devices');
        }

        function onViewDeviceButtonClick(device) {
          if ($scope.loading) {
            return;
          }
          goToViewDevice(device);
        }

        function onShowMoreTagsButtonClick(device, $event) {
          $event.stopPropagation();
          if ($scope.loading) {
            return;
          }
          goToViewDevice(device);
        }

        function goToViewDevice(device, tab) {
          utils.setStorageItem(SELECTED_DEVICE_LOCAL_STORAGE_KEY, device);
          $state.go('main.devices.edit', {
            from: 'location',
            locationId: device.locationId,
            tab: tab
          });
          $rootScope.$emit('refreshChooseMenuEvent', 'devices');
        }

        function onDeleteDeviceButtonClick(device) {
          if ($scope.loading) {
            return;
          }
          $('#delete-device-dialog')
            .modal({
              closable: true,
              detachable: true,
              onApprove: function() {
                deleteDevice(device);
              }
            }).modal('show');
        }

        function deleteDevice(device) {
          $scope.loading = true;
          return $scope.dataProvider.removeLocationDevice(device)
            .then(() => {
              ToastsService.success(null, $t('common.delete-device-success'));
              processDevices();
              $scope.loading = false;
            }, err => {
              $scope.loading = false;
              utils.handleApiError(err);
            });
        }

        function onCloneDeviceButtonClick(device) {
          if ($scope.loading || !device || !(device.simulated == null || device.simulated === -1)) {
            return;
          }
          $scope.deviceCloneInfo = {
            device: device
          };

          $('#clone-device-modal')
            .modal({
              closable: true,
              detachable: true,
              onApprove: function() {
                cloneDevice();
              }
            }).modal('show');
        }

        function cloneDevice() {
          $scope.loading = true;

          const device = $scope.deviceCloneInfo.device;
          const location = $scope.deviceCloneInfo.location;

          return $scope.dataProvider.cloneLocationDevice(device, location)
            .then(() => {
              ToastsService.success(null, $t('common.clone-device-success'));
              processDevices();
              $scope.loading = false;
            }, err => {
              $scope.loading = false;
              utils.handleApiError(err);
            });
        }

        function searchLocations(searchTerm, globalSearch) {
          $scope.deviceCloneInfo.searching = true;
          return $scope.dataProvider.searchLocations(searchTerm, globalSearch)
            .then((locations) => {
              $scope.deviceCloneInfo.locations = locations;
              $scope.deviceCloneInfo.searching = false;
              return $scope.deviceCloneInfo.locations;
            }, err => {
              $scope.deviceCloneInfo.locations = undefined;
              $scope.deviceCloneInfo.searching = false;
              utils.handleApiError(err);
            });
        }

        function selectLocation(location) {
          $scope.deviceCloneInfo.location = location;
        }

        /**
         * Check if we need to show "no device found" message
         * @return {boolean}
         */
        function checkNoDevicesFound() {
          if ($scope.loading) {
            return false;
          }

          if (!$scope.otherDevices || $scope.otherDevices.length === 0 || !$scope.gateways || $scope.gateways.length === 0) {
            return false;
          }

          if ($scope.filteredOtherDevices && $scope.filteredOtherDevices.length > 0) {
            return false;
          }

          return !$scope.gateways.some(gateway => {
            let filteredDevices = gateway.devices || [];
            filteredDevices = $filter('filter')(filteredDevices, $scope.filterByStatus) || [];
            filteredDevices = $filter('filter')(filteredDevices, $scope.searchVal) || [];
            return filteredDevices.length > 0;
          });
        }

        /**
         * Check if current device is a Gateway
         * @return {boolean}
         */
        function isGateway(device) {
          return $scope.dataProvider.isGateway(device);
        }
      }
    };
  })
  .name;
